import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { z } from "zod"

export const FrontendUpdateSizeChartMetafieldSchema = z.object({
  productId: z.string().trim().min(1, { message: "Required" }),
  variantId: z.string().optional(),
  sizeChartMetafieldKey: z.string().trim().min(1, { message: "Required" }),
  imageMetafieldKey: z.string().trim().min(1, { message: "Required" }),
  metafieldValue: z.string(),
})

type UpdateSizeChartMetafieldPayload = {
  productId: string
  variantId?: string
  metafields: {
    key: string
    type: string
    value?: string
    base64Image?: string
    jsonFile?: string
  }[]
}

export function useShopifyUpdateSizeChartMetafieldMutation() {
  return useMutation({
    mutationFn: async ({ productId, variantId, metafields }: UpdateSizeChartMetafieldPayload) => {
      await axios.post(`/integrations/shopify/size-chart/${encodeURIComponent(productId)}`, {
        metafields,
        variantId,
      })
    },
  })
}
